import { IIconClickProps } from "../../interfaces/IIconProps";
import commonStyles from "../Common.module.css";

export default ({ onClick }: IIconClickProps) => (
    <svg className={commonStyles.clickableIcon} onClick={onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.8833 2.99165L17.0083 4.11665C17.6667 4.76665 17.6667 5.82498 17.0083 6.47498L5.98333 17.5H2.5V14.0167L11.1667 5.34165L13.525 2.99165C14.175 2.34165 15.2333 2.34165 15.8833 2.99165ZM4.16667 15.8333L5.34167 15.8833L13.525 7.69165L12.35 6.51665L4.16667 14.7V15.8333Z" fill="#202020" />
    </svg>
);